
<template>
<vs-card>
 <vs-row vs-justify="center">
  <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
        <div class="p-4 flex flex-col w-full">
            <h3>Órdenes</h3>
        </div>
        <div class="p-4 flex flex-col w-full">
        <vs-table
            pagination
            max-items="5"
            search
            :data="listOrderProduct">
                <template slot="header">
                    <h3>
                    </h3>
                </template>
                <template slot="thead">
                    <vs-th sort-key="apellidos">
                    CLIENTE
                    </vs-th>
                    <vs-th sort-key="fecha_creacion">
                    FECHA
                    </vs-th>
                    <vs-th sort-key="id_orden_compra_cab">
                    NUM_ÓRDEN
                    </vs-th>
                    <!-- <vs-th sort-key="numero_ordenes">
                    NUM_ÓRDENES
                    </vs-th> -->
                    <vs-th sort-key="subTotalConIva">
                    SUB_IVA
                    </vs-th>
                    <vs-th sort-key="subTotalSinIva">
                    SUB_SIN_IVA
                    </vs-th>
                    <vs-th sort-key="iva">
                    IVA
                    </vs-th>
                    <vs-th sort-key="total">
                    TOT
                    </vs-th>
                    <vs-th sort-key="OPCIONES">
                    OCP
                    </vs-th>
                </template>

                <template slot-scope="{data}">
                    
                    <vs-tr :data="tr" :state="indextr%2 != 0 ? '' : 'dark'" :key="indextr" v-for="(tr, indextr) in data" >

                    <vs-td :data="data[indextr].apellidos+''+data[indextr].nombres">
                        {{data[indextr].apellidos}} {{data[indextr].nombres}}
                    </vs-td>
                    <vs-td :data="data[indextr].fecha_creacion">
                        {{data[indextr].fecha_creacion}}
                    </vs-td>
                    <!-- <vs-td :data="data[indextr].numero_ordenes">
                        {{data[indextr].numero_ordenes}}
                    </vs-td> -->
                    <vs-td :data="data[indextr].id_orden_compra_cab">
                        {{data[indextr].id_orden_compra_cab}}
                    </vs-td>
                    <vs-td :data="data[indextr].subTotalConIva">
                        {{parseFloat(data[indextr].subTotalConIva).toFixed(4)}}
                    </vs-td>

                    <vs-td :data="data[indextr].subTotalSinIva">
                        {{parseFloat(data[indextr].subTotalSinIva).toFixed(4)}}
                    </vs-td>

                    <vs-td :data="data[indextr].iva">
                        {{parseFloat(data[indextr].iva).toFixed(4)}}
                    </vs-td>
                    <vs-td :data="data[indextr].total">
                        {{parseFloat(data[indextr].total).toFixed(2)}}
                    </vs-td>
                    <vs-td>
                        <vs-button type="border" size="small" icon-pack="feather"  class="mr-2" @click="verRegister(data[indextr])">
                        <i class="material-icons">remove_red_eye</i>
                        </vs-button>
                    </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
            <!-- PROCESO DE MODAL  -->
                <div class="centerx">
                    <vs-popup  fullscreen classContent="popup-example" title="Datos de Órdenes"  :active.sync="activarModal">
                    <vs-row vs-w="12">
                        <vs-col vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                            <span><b>Número de Orden: </b>{{ordenCompra.id_orden_compra_cab}}
                            </span>
                        </vs-col>
                        <vs-col vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                             <span><b>Número de Identificación: </b>{{ordenCompra.numero_identificacion}}</span>
                        </vs-col>
                        <vs-col vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                            <span><b>Nombres: </b>{{ordenCompra.apellidos}}  {{ordenCompra.nombres}}</span>
                        </vs-col>
                    </vs-row>
                    <vs-row vs-w="12">
                        <vs-col vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                            <span><b>Fecha: </b>{{ordenCompra.fecha_completa}} </span>
                        </vs-col>
                        <vs-col vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                             <span><b>Email: </b>{{ordenCompra.email}}</span>
                        </vs-col>
                        <vs-col vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                            <span><b>Teléfono: </b>{{ordenCompra.cli_telefono}} </span>
                        </vs-col>
                        <vs-col vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                            <span><b>Celular:</b> {{ordenCompra.cli_celular}}</span>
                        </vs-col>
                    </vs-row>
                    <div class="p-4 flex flex-col w-full" :key="indextr" v-for="(estudiante, indextr) in ordenCompra.detalle">
                        <vs-row vs-w="12">
                            <vs-col vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                                <span><b>Estudiante: </b>{{estudiante.estudiante.detalle_productos[0].apellidos}} {{estudiante.estudiante.detalle_productos[0].nombres}}   </span>
                            </vs-col>
                        </vs-row>
                        <vs-table
                        pagination
                        max-items="5"
                        search
                            :data="estudiante.estudiante.detalle_productos">
                            <template slot="header">
                            <!-- nombres apellidos numero_identificacion curso nom_producto cod_producto precio unidades subtotal descuento iva total-->
                                <h3>
                                </h3>
                            </template>
                            <template slot="thead">
                                <vs-th sort-key="NOM PRODUCT" style="width:50% !important;">
                                NOM_PRODUCT
                                </vs-th>
                                <vs-th sort-key="UNIDADES">
                                UNIDADES
                                </vs-th>
                                <vs-th sort-key="PRECIO">
                                PRECIO
                                </vs-th>
                                <vs-th sort-key="SUBTOTAL">
                                SUBTOTAL
                                </vs-th>
                                <vs-th sort-key="DESCUENTO">
                                DESCUENTO
                                </vs-th>
                                <vs-th sort-key="TOTAL">
                                TOTAL
                                </vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <vs-tr :data="tr" :state="indextr%2 != 0 ? '' : 'dark'" :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td :data="data[indextr].nom_producto">
                                    {{data[indextr].nom_producto}}
                                </vs-td>
                                <vs-td :data="data[indextr].unidades">
                                    {{data[indextr].unidades}}
                                </vs-td>
                                <vs-td :data="data[indextr].precio">
                                    {{data[indextr].precio}}
                                </vs-td>
                                <vs-td :data="data[indextr].subtotal">
                                    {{data[indextr].subtotal}}
                                </vs-td>
                                <vs-td :data="data[indextr].descuento">
                                    {{data[indextr].descuento}}
                                </vs-td>
                                <vs-td :data="data[indextr].total">
                                    {{data[indextr].total}}
                                </vs-td>
                                </vs-tr>
                            </template>
                    </vs-table>
                    <div class="vx-row justify-end">
					    <div class="vx-col sm:w-1/5 w-full mb-2"><b>Subtotal Con Iva: $</b>
                            <span v-text="parseFloat(estudiante.estudiante.detalle_orden.subtotalConIva).toFixed(4)">
                            </span></div>
					    <div class="vx-col sm:w-1/5 w-full mb-2"> <b>Subtotal Sin Iva: $</b>
                                <span v-text="parseFloat(estudiante.estudiante.detalle_orden.subtotalSinIva).toFixed(4)">
                            </span></div>
					    <div class="vx-col sm:w-1/5 w-full mb-2"><b>Descuento: $</b>
                            <span v-text="parseFloat(estudiante.estudiante.detalle_orden.descuento).toFixed(4)">
                            </span></div>
					    <div class="vx-col sm:w-1/5 w-full mb-2"><b>Iva: $</b>
                            <span v-text="parseFloat(estudiante.estudiante.detalle_orden.iva).toFixed(4)">
                            </span></div>
					    <div class="vx-col sm:w-1/5 w-full mb-2"><b>Total: $</b>
                            <span v-text="parseFloat(estudiante.estudiante.detalle_orden.total).toFixed(4)">
                            </span></div>
                    </div>
                    </div>
                    <div class="vx-col lg:w-1/3 w-full alineacionDetalle">
                        <vx-card title="">
                            <!-- <div class="flex justify-between mb-2">
                                <span class="text-grey">Subtotal:</span>
                                <span style="text-align:end;">
                                <span v-text="parseFloat(ordenCompra.subtotal).toFixed(4)">
                                </span>
                                </span>
                            </div> -->
                            <div class="flex justify-between mb-2">
                                <span class="text-grey">Subtotal Con Iva:</span>
                                <span style="text-align:end;">
                                <span v-text="parseFloat(ordenCompra.subTotalConIva).toFixed(4)">
                                </span>
                                </span>
                            </div>
                            <div class="flex justify-between mb-2">
                                <span class="text-grey">Subtotal Sin Iva:</span>
                                <span style="text-align:end;">
                                <span v-text="parseFloat(ordenCompra.subTotalSinIva).toFixed(4)">
                                </span>
                                </span>
                            </div>
                            <div class="flex justify-between mb-2">
                                <span class="text-grey">Descuento:</span>
                                <span style="text-align:end;">
                                <span v-text="parseFloat(ordenCompra.descuento).toFixed(2)">
                                </span>
                                </span>
                            </div>
                            <div class="flex justify-between mb-2">
                                <span class="text-grey">Iva:</span>
                                <span style="text-align:end;">
                                <span v-text="parseFloat(ordenCompra.iva).toFixed(4)">
                                </span>
                                </span>
                            </div>
                            <div class="flex justify-between mb-2">
                                <span class="text-grey">Total:</span>
                                <span style="text-align:end;">
                                <span v-text="parseFloat(ordenCompra.total).toFixed(2)">
                                </span>
                                </span>
                            </div>
                        </vx-card>
                    </div>
                    </vs-popup>
                </div>
            <!-- FIN DE PROCESO DE MODAL -->
    </vs-col>
   </vs-row>
</vs-card>
</template>
<script>
export default {
    data(){
        return {
            listOrderProduct:[],
            anio:null,
            selected:[],
            activarModal:false,
            ordenCompra:{
                email: null,
                nombres: null,
                apellidos: null,
                numero_identificacion: null,
                cli_telefono: null,
                cli_celular: null,
                cod_persona: null,
                cod_cliente: null,
                pais: null,
                provincia: null,
                canton: null,
                parroquia: null,
                direccion: null,
                referencia: null,
                dir_telefono: null,
                dir_celular: null,
                tipo_pago: null,
                tipo_entrega: null,
                subtotal: null,
                descuento: null,
                iva: null,
                transporte: null,
                total: null,
                id_usuario: null,
                id_orden_compra_cab: null,
                anio: null,
                fecha_creacion: null,
                detalle: []

            },

        }
    },
    methods:{
        verRegister(registro){
            this.activarModal = true;
            this.$vs.loading();
                axios.post(this.$store.state.domain+`mapgrafi/ordenes-compra/ordenes-compra-carga-general`,{
                    evento:"LC", // DEVUELVE CON LOS DETALES SELECCIONADOS
                    anio:this.anio,
                    id_usuario:this.$store.state.AppActiveUser.id_usuario,
                    id_usuario_cliente:null,
                    id_usuario_direccion:null,
                    nombres_facturado:null,
                    numero_identificacion:null,
                    id_orden_compraCab:registro.id_orden_compra_cab,
                    estado:"A"
                  })
                  .then((response) => { 
                    this.$vs.loading.close();
                    if(response.status != 200) throw 'ERROR EN EL SERVIDOR';
                      if(response.data.existeError) throw 'Error '.response.data.mensaje;
                        this.ordenCompra    = _.clone(response.data.data[0]);
                        // this.listOrderProduct   =   response.data.data;
                  })
                  .catch(error=>{
                      this.$vs.loading.close();
                      this.$vs.notify({
                          time:8000,
                          title: '',
                          text: error,
                          iconPack: 'feather',
                          icon: 'icon-alert-circle',
                          color: 'warning'
                      })
                  });

        },
        loadGeneralOrderBuy(){
            this.$vs.loading();
                axios.post(this.$store.state.domain+`mapgrafi/ordenes-compra/ordenes-compra-carga-general`,{
                    
                    evento:"L",
                    anio:this.anio,
                    id_usuario:this.$store.state.AppActiveUser.id_usuario,
                    id_usuario_cliente:null,
                    id_usuario_direccion:null,
                    nombres_facturado:null,
                    numero_identificacion:null,
                    estado:"A"
                  })
                  .then((response) => { 
                    this.$vs.loading.close();
                    if(response.status != 200) throw 'ERROR EN EL SERVIDOR';
                      if(response.data.existeError) throw 'Error '.response.data.mensaje;
                        this.listOrderProduct   =   response.data.data;
                  })
                  .catch(error=>{
                      this.$vs.loading.close();
                      this.$vs.notify({
                          time:8000,
                          title: '',
                          text: error,
                          iconPack: 'feather',
                          icon: 'icon-alert-circle',
                          color: 'warning'
                      })
                  });
        },
        validatorOnline(){
            if(!this.$store.state.AppActiveUser.status)
            this.$router.push('/');
            else
                this.loadGeneralOrderBuy();
        },
    },
    created(){
      this.validatorOnline();
    }
}
</script>

<style>

.alineacionDetalle{
    float:right !important;
}
</style>

